import axios from "axios";
import APIURL from "../../Main/apiurl";


const set_opening_balance = async (registryData) => {

  try {
    const data = {
      balance: registryData,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/set-opening-balance`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_opening_balance = async () => {
  try {
    const data = {};

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-opening-balance`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_open_invoices = async () => {
  try {
    const data = {};

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-open-invoices`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};


const close_registry = async (registryData) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/close-registry`,
      registryData,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const check_registry_status = async () => {
  try {
    const data = {};

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/check-registry-status`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_registries = async (registryData) => {
  try {
    const data = {
      search: registryData?.search,
      date:registryData?.date,
      page: registryData?.page,
      limit: registryData?.limit,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-registries`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_registry_details = async (registryData) => {
  try {
    const data = {
      id: registryData?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-registry-details`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_registry_report = async (registryData) => {
  try {
    const data = {
      start_date: registryData?.start_date,
      end_date: registryData?.end_date,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-registry-report`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const reopen_registry = async (registryData) => {
  try {
    const data = {
      id: registryData?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/reopen-registry`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  set_opening_balance,
  get_opening_balance,
  close_registry,
  check_registry_status,
  get_all_registries,
  get_registry_details,
  get_registry_report,
  reopen_registry,
  get_open_invoices
};